import { Link } from 'react-router-dom';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const hero = () => {
    return (
        <section className="hero_section">
            <div className="bg_shape">
                <svg viewBox="0 0 1920 1075" fill="none">
                    <path d="M0 0H1920V1000C1920 1000 1632 619 962 917C292 1215 0 1000 0 1000V0Z" fill="#EBF7FF" />
                </svg>
            </div>
            <div className="content">
                <div className="hero-text">
                    <h1>
                        <span className="name">Advanced Regenerative Medicine, Proven Results</span>
                        <span className="degree">20+ Years Experience • FIPP & ABIPP Certified • 1000+ Procedures</span>
                    </h1>
                    <div className="title-line">
                        <h2 className="name" style={{color: "#0A91B1", fontWeight: "bold"}}>Dr. Eugene Pereira, MD.</h2>
                        <span>Board-Certified Pain Management Specialist</span>
                    </div>
                    <p className="description">
                        With over 20 years of expertise in interventional pain management and 
                        regenerative medicine, Dr. Pereira offers comprehensive, personalized treatment 
                        plans utilizing the latest advances in stem cell therapy, PRP, and minimally 
                        invasive procedures. His patient-centered approach focuses on addressing the 
                        root cause of pain, not just symptoms, to help you reclaim your quality of life.
                    </p>
                    <div className="cta-section">
                        <Link onClick={ClickHandler} className="theme-btn primary" to="/contact">
                            <i className="fa fa-phone"></i>
                            Book Consultation
                        </Link>
                        <Link onClick={ClickHandler} className="theme-btn secondary" to="/about">
                            <i className="fa fa-plus"></i>
                            About My Approach
                        </Link>
                    </div>
                </div>
            </div>
            <div className="image_content">
                <div className="image">
                    <img src="/hero-image.jpg" alt="" />
                </div>
            </div>
        </section>
    );
}

export default hero;